import { render, staticRenderFns } from "./GuiaRegalos.vue?vue&type=template&id=6e9dde9e"
import script from "./GuiaRegalos.vue?vue&type=script&lang=js"
export * from "./GuiaRegalos.vue?vue&type=script&lang=js"
import style0 from "./GuiaRegalos.vue?vue&type=style&index=0&id=6e9dde9e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports